import React from 'react';
import { Modal, Form, Checkbox, Input } from 'antd';

const REJECT_REASONS = [
  { value: '信息不完整', label: '信息不完整（关键字段缺失或为空）' },
  { value: '数据有误', label: '数据有误（数值异常、格式错误等）' },
  { value: '不符合填报要求', label: '不符合填报要求（口径/范围不符合说明）' },
  { value: '重复提交', label: '重复提交或与其他记录高度重复' },
  { value: '其他', label: '其他原因' }
];

/**
 * 统一拒绝问卷弹窗组件
 *
 * @param {Object} props
 * @param {boolean} props.visible - 是否显示
 * @param {function} props.onCancel - 取消回调
 * @param {function} props.onOk - 提交回调
 * @param {boolean} props.confirmLoading - 提交中状态
 * @param {Object} props.form - Ant Design Form 实例
 * @param {React.ReactNode} [props.children] - 可选的自定义内容（如数据行预览），显示在拒绝原因之前
 */
const RejectModal = ({ visible, onCancel, onOk, confirmLoading, form, children }) => {
  const handleCancel = () => {
    form?.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="拒绝问卷"
      open={visible}
      onCancel={handleCancel}
      onOk={onOk}
      confirmLoading={confirmLoading}
      okText="提交"
      cancelText="取消"
      width={1000}
    >
      <Form form={form} layout="vertical">
        {children}
        <Form.Item
          label="拒绝原因（可多选）"
          name="reason"
          rules={[{ required: true, message: '请选择至少一项拒绝原因' }]}
        >
          <Checkbox.Group style={{ width: '100%' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 12 }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #E1E5EB', padding: '8px', width: '40%', background: '#f5f7fa' }}>原因类别</th>
                  <th style={{ border: '1px solid #E1E5EB', padding: '8px', background: '#f5f7fa' }}>勾选</th>
                </tr>
              </thead>
              <tbody>
                {REJECT_REASONS.map(item => (
                  <tr key={item.value}>
                    <td style={{ border: '1px solid #E1E5EB', padding: '8px' }}>{item.label}</td>
                    <td style={{ border: '1px solid #E1E5EB', padding: '8px', textAlign: 'center' }}>
                      <Checkbox value={item.value} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item
          label="具体说明（选填）"
          name="detail"
        >
          <Input.TextArea
            rows={4}
            placeholder="请详细说明拒绝原因，如需指出哪一行、哪一列有问题，可在此描述。"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectModal;
